"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeBridgeMessageTypes = void 0;
/**
 * These are types that are used in communication between the native app
 * wrapper in expo and the web app
 **/
exports.NativeBridgeMessageTypes = {
    GetAuthStatus: "GetAuthStatus",
    Token: "Token",
    GetWorkouts: "GetWorkouts",
    SetWorkouts: "SetWorkouts",
    EnableDebug: "EnableDebug",
    Nav: "Nav",
    // Notifications comms
    SetNotificationsEnabled: "SetNotificationsEnabled",
    // trigger the native app to prompt the user to allow notifications
    PromptAllowNotifications: "PromptAllowNotifications",
    // Health comms
    // Trigger the native app to prompt the user to allow access to health data
    PromptAllowHealth: "PromptAllowHealth",
    SetHealthEnabled: "SetHealthEnabled",
    // Web asks RN wrapper if health is enabled. That way it can conditionally
    // show messaging about why we use health data and ask the user to grant
    // access.
    CheckHealthEnabled: "CheckHealthEnabled",
    // RN Wrapper sends back the result
    CheckHealthEnabledResult: "CheckHealthEnabledResult",
    // Web asks RN wrapper if it should use health data. NOTE: it's disabled in
    // Android for now.
    CheckShouldUseHealth: "CheckShouldUseHealth",
    CheckShouldUseHealthResult: "CheckShouldUseHealthResult",
};
//# sourceMappingURL=NativeAppBridge.js.map